export { default } from './CourseInformation';
export type { Props, Props as CourseInformationProps } from './CourseInformation';
